import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/projects'

/**
 * Context evaluation service for evaluation history.
 */
class ContextEvaluationService {
    /**
     * Get evaluation history for a context.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {string} contextUlid - Context ULID
     * @returns {Promise<Object>} Evaluation response
     */
    async get(projectKey, environmentKey, contextUlid) {
        return await apiClient
            .get(
                API_INTERNAL_BASE +
                    '/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/contexts/' +
                    contextUlid +
                    '/evaluations'
            )
            .then((response) => {
                return response.data
            })
    }
}

export default new ContextEvaluationService()
